<template>
    <router-link class="px-3 py-2 d-block side-menu-link" :class="cssClass" :to="to">
        <slot/>
    </router-link>
</template>

<script type="text/javascript">

    export default {

        props: {
            to: {
                type: String,
                required: true,
            },

            group: {
                type: String,
                required: false,
            },

            ignoreGroup: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            cssClass() {
                let cls = [];
                let group = this.group;
                if (!group) group = this.to;
                if (
                    (this.$route.path == this.to) ||
                    ((!this.ignoreGroup) && (this.$route.meta) && (this.$route.meta.group) && (this.$route.meta.group == group))
                ) {
                    cls.push('active');
                }

                return cls;
            },
        },

        
    };

</script>
